import { Component, Injector, OnInit } from "@angular/core";

import { StepManagerService } from "@core/services/online-credit/step-manager.service";
import { StoreService } from "../store/store.service";
import { LifecycleHookLogs } from '@shared/decorators/lifecycle-hook-logs/lifecycle-hook-logs.decorator';
import { UntilDestroy } from '@ngneat/until-destroy';

@LifecycleHookLogs()
@UntilDestroy()
@Component({
    selector: 'app-loan-was-hastily-issued-step',
    templateUrl: 'loan-was-hastily-issued-step.page.html',
    standalone: false
})

export class LoanWasHastilyIssuedStepPage implements OnInit {

  private stepManager: StepManagerService
  private store: StoreService;

  public id: any;

  constructor(
    private injector: Injector
  ) {
    this.stepManager = this.injector.get(StepManagerService)
    this.store = this.injector.get(StoreService);
    this.id = this.store.value.application ? this.store.value.application.id : null;
  }

  ngOnInit() {
    setTimeout(() => {
      this.stepManager.setStepLoaded(true);
    })
  }

  cancel() {
    this.stepManager.goToRoot();
  }
}
